import { Component, inject, input } from '@angular/core';
import {
	ApiRequestOrdering,
	ApiPaginatedResponse,
	VehicleMakeSearchDto,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { ListDisplaySectionItemComponent } from '../../../../shared/components/list-display-section/components/list-display-section-item/list-display-section-item.component';
import { SearchableStrategy } from '../../../../shared/models/searchable-strategy.model';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { mapDtoToModelVehicleMakes } from '../vehicles-record/components/vehicles-make-model/mappers/search-dto-to-model.mapper';
import { VehicleMakesService } from '../vehicles-record/components/vehicles-make-model/services/vehicle-makes.service';

@Component({
	selector: 'app-vehicle-make-selected-item',
	imports: [ListDisplaySectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-list-display-section-item
			[plain]="true"
			[svgIcon]="'stat_0'"
			class="w-full"
			[item]="item()"
			[module]="item().module">
		</app-list-display-section-item>
	`,
})
class VehicleMakeSelectedItemComponent {
	item = input<SelectItem<VehicleMakeSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleMakeSearchStrategy implements SearchableStrategy<VehicleMakeSearchDto> {
	#vehicleMakesService = inject(VehicleMakesService);

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: any,
		page: number,
		ordering: ApiRequestOrdering,
	): Observable<ApiPaginatedResponse<any[]>> {
		return this.#vehicleMakesService.getSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
			ordering,
		);
	}

	selectedItemDisplay = VehicleMakeSelectedItemComponent;

	mapDtoToModel(
		items: VehicleMakeSearchDto[],
	): SelectItem<VehicleMakeSearchDto>[] {
		return mapDtoToModelVehicleMakes(items);
	}
}
